import {ManualArticle, getPage} from '@area-monitoring/am-app-manual';
import {Typography} from '@mui/material';
import {createFileRoute, getRouteApi} from '@tanstack/react-router';
import {useTranslation} from 'react-i18next';

const routeApi = getRouteApi('/$slug');

const PageComponent: React.FC = () => {
  const {slug} = routeApi.useParams();
  const {i18n, t} = useTranslation();
  const page = getPage(i18n.language, slug);

  if (!page) {
    return (
      <ManualArticle>
        <Typography variant="h5">{t('page-not-found')}</Typography>
      </ManualArticle>
    );
  }

  const Content = page.Component;
  return (
    <ManualArticle>
      <Content />
    </ManualArticle>
  );
};

export const Route = createFileRoute('/$slug')({
  component: PageComponent,
});
